/** Escape the former immutable cache once; repaired image bytes now revalidate. */
export function cachedImageUrl(hash: string): string {
  return `/api/image/${hash}?v=2`;
}
